/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { projectCalculationsProjectsScenariosRetrieve } from '../fn/scenarios/project-calculations-projects-scenarios-retrieve';
import { ProjectCalculationsProjectsScenariosRetrieve$Params } from '../fn/scenarios/project-calculations-projects-scenarios-retrieve';
import { projectCalculationsScenarioCompareExcelRetrieve } from '../fn/scenarios/project-calculations-scenario-compare-excel-retrieve';
import { ProjectCalculationsScenarioCompareExcelRetrieve$Params } from '../fn/scenarios/project-calculations-scenario-compare-excel-retrieve';
import { projectCalculationsScenarioCompareRetrieve } from '../fn/scenarios/project-calculations-scenario-compare-retrieve';
import { ProjectCalculationsScenarioCompareRetrieve$Params } from '../fn/scenarios/project-calculations-scenario-compare-retrieve';
import { projectCalculationsVariantsKitsCreate } from '../fn/scenarios/project-calculations-variants-kits-create';
import { projectCalculationsVariantsKitsCreate$FormData } from '../fn/scenarios/project-calculations-variants-kits-create-form-data';
import { ProjectCalculationsVariantsKitsCreate$FormData$Params } from '../fn/scenarios/project-calculations-variants-kits-create-form-data';
import { ProjectCalculationsVariantsKitsCreate$Params } from '../fn/scenarios/project-calculations-variants-kits-create';
import { projectCalculationsVariantsKitsCreate$XWwwFormUrlencoded } from '../fn/scenarios/project-calculations-variants-kits-create-x-www-form-urlencoded';
import { ProjectCalculationsVariantsKitsCreate$XWwwFormUrlencoded$Params } from '../fn/scenarios/project-calculations-variants-kits-create-x-www-form-urlencoded';
import { projectCalculationsVariantsKitsDestroy } from '../fn/scenarios/project-calculations-variants-kits-destroy';
import { ProjectCalculationsVariantsKitsDestroy$Params } from '../fn/scenarios/project-calculations-variants-kits-destroy';
import { projectCalculationsVariantsKitsEnumsRetrieve } from '../fn/scenarios/project-calculations-variants-kits-enums-retrieve';
import { ProjectCalculationsVariantsKitsEnumsRetrieve$Params } from '../fn/scenarios/project-calculations-variants-kits-enums-retrieve';
import { projectCalculationsVariantsKitsList } from '../fn/scenarios/project-calculations-variants-kits-list';
import { ProjectCalculationsVariantsKitsList$Params } from '../fn/scenarios/project-calculations-variants-kits-list';
import { projectCalculationsVariantsKitsPartialUpdate } from '../fn/scenarios/project-calculations-variants-kits-partial-update';
import { projectCalculationsVariantsKitsPartialUpdate$FormData } from '../fn/scenarios/project-calculations-variants-kits-partial-update-form-data';
import { ProjectCalculationsVariantsKitsPartialUpdate$FormData$Params } from '../fn/scenarios/project-calculations-variants-kits-partial-update-form-data';
import { ProjectCalculationsVariantsKitsPartialUpdate$Params } from '../fn/scenarios/project-calculations-variants-kits-partial-update';
import { projectCalculationsVariantsKitsPartialUpdate$XWwwFormUrlencoded } from '../fn/scenarios/project-calculations-variants-kits-partial-update-x-www-form-urlencoded';
import { ProjectCalculationsVariantsKitsPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/scenarios/project-calculations-variants-kits-partial-update-x-www-form-urlencoded';
import { projectCalculationsVariantsKitsRetrieve } from '../fn/scenarios/project-calculations-variants-kits-retrieve';
import { ProjectCalculationsVariantsKitsRetrieve$Params } from '../fn/scenarios/project-calculations-variants-kits-retrieve';
import { projectCalculationsVariantsKitsUpdate } from '../fn/scenarios/project-calculations-variants-kits-update';
import { projectCalculationsVariantsKitsUpdate$FormData } from '../fn/scenarios/project-calculations-variants-kits-update-form-data';
import { ProjectCalculationsVariantsKitsUpdate$FormData$Params } from '../fn/scenarios/project-calculations-variants-kits-update-form-data';
import { ProjectCalculationsVariantsKitsUpdate$Params } from '../fn/scenarios/project-calculations-variants-kits-update';
import { projectCalculationsVariantsKitsUpdate$XWwwFormUrlencoded } from '../fn/scenarios/project-calculations-variants-kits-update-x-www-form-urlencoded';
import { ProjectCalculationsVariantsKitsUpdate$XWwwFormUrlencoded$Params } from '../fn/scenarios/project-calculations-variants-kits-update-x-www-form-urlencoded';
import { BackendScenarioDto } from '../models/backend-scenario-dto';

@Injectable({ providedIn: 'root' })
export class BackendApiScenariosService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `projectCalculationsProjectsScenariosRetrieve()` */
  static readonly ProjectCalculationsProjectsScenariosRetrievePath =
    '/api/project_calculations/projects/{project_id}/scenarios/';

  /**
   * Компактный список сценариев проекта (для селектора сравнения).
   *
   * Возвращает только id/name/description/created_by/is_calculated. Outsider получает 404 (anti-leak).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectCalculationsProjectsScenariosRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCalculationsProjectsScenariosRetrieve$Response(
    params: ProjectCalculationsProjectsScenariosRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return projectCalculationsProjectsScenariosRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Компактный список сценариев проекта (для селектора сравнения).
   *
   * Возвращает только id/name/description/created_by/is_calculated. Outsider получает 404 (anti-leak).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectCalculationsProjectsScenariosRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCalculationsProjectsScenariosRetrieve(
    params: ProjectCalculationsProjectsScenariosRetrieve$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.projectCalculationsProjectsScenariosRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `projectCalculationsScenarioCompareRetrieve()` */
  static readonly ProjectCalculationsScenarioCompareRetrievePath = '/api/project_calculations/scenario_compare/';

  /**
   * Сравнение N сценариев с эталоном.
   *
   * Multi-scenario compare. baseline полностью сериализуется (composition + metrics); others отдаются только с metrics и diff_vs_baseline (без полной composition).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectCalculationsScenarioCompareRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCalculationsScenarioCompareRetrieve$Response(
    params: ProjectCalculationsScenarioCompareRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return projectCalculationsScenarioCompareRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Сравнение N сценариев с эталоном.
   *
   * Multi-scenario compare. baseline полностью сериализуется (composition + metrics); others отдаются только с metrics и diff_vs_baseline (без полной composition).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectCalculationsScenarioCompareRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCalculationsScenarioCompareRetrieve(
    params: ProjectCalculationsScenarioCompareRetrieve$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.projectCalculationsScenarioCompareRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `projectCalculationsScenarioCompareExcelRetrieve()` */
  static readonly ProjectCalculationsScenarioCompareExcelRetrievePath =
    '/api/project_calculations/scenario_compare/excel';

  /**
   * XLSX-экспорт таблицы сравнения сценариев.
   *
   * Возвращает готовый XLSX (Content-Type application/vnd.openxmlformats-officedocument.spreadsheetml.sheet) с шапкой, секциями и таблицей значений + дельт. Параметры/валидация и anti-leak полностью идентичны GET /scenario_compare/ — переиспользуется тот же сериализатор и diff_vs_baseline. Pagination в Excel НЕ применяется (лимит 10 others сразу).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectCalculationsScenarioCompareExcelRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCalculationsScenarioCompareExcelRetrieve$Response(
    params: ProjectCalculationsScenarioCompareExcelRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return projectCalculationsScenarioCompareExcelRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * XLSX-экспорт таблицы сравнения сценариев.
   *
   * Возвращает готовый XLSX (Content-Type application/vnd.openxmlformats-officedocument.spreadsheetml.sheet) с шапкой, секциями и таблицей значений + дельт. Параметры/валидация и anti-leak полностью идентичны GET /scenario_compare/ — переиспользуется тот же сериализатор и diff_vs_baseline. Pagination в Excel НЕ применяется (лимит 10 others сразу).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectCalculationsScenarioCompareExcelRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCalculationsScenarioCompareExcelRetrieve(
    params: ProjectCalculationsScenarioCompareExcelRetrieve$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.projectCalculationsScenarioCompareExcelRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `projectCalculationsVariantsKitsList()` */
  static readonly ProjectCalculationsVariantsKitsListPath = '/api/project_calculations/variants_kits/';

  /**
   * create and view scenarios
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectCalculationsVariantsKitsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCalculationsVariantsKitsList$Response(
    params?: ProjectCalculationsVariantsKitsList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendScenarioDto>>> {
    return projectCalculationsVariantsKitsList(this.http, this.rootUrl, params, context);
  }

  /**
   * create and view scenarios
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectCalculationsVariantsKitsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCalculationsVariantsKitsList(
    params?: ProjectCalculationsVariantsKitsList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendScenarioDto>> {
    return this.projectCalculationsVariantsKitsList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendScenarioDto>>): Array<BackendScenarioDto> => r.body),
    );
  }

  /** Path part for operation `projectCalculationsVariantsKitsCreate()` */
  static readonly ProjectCalculationsVariantsKitsCreatePath = '/api/project_calculations/variants_kits/';

  /**
   * create and view scenarios
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectCalculationsVariantsKitsCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectCalculationsVariantsKitsCreate$Response(
    params: ProjectCalculationsVariantsKitsCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendScenarioDto>> {
    return projectCalculationsVariantsKitsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * create and view scenarios
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectCalculationsVariantsKitsCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectCalculationsVariantsKitsCreate(
    params: ProjectCalculationsVariantsKitsCreate$Params,
    context?: HttpContext,
  ): Observable<BackendScenarioDto> {
    return this.projectCalculationsVariantsKitsCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendScenarioDto>): BackendScenarioDto => r.body),
    );
  }

  /**
   * create and view scenarios
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectCalculationsVariantsKitsCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectCalculationsVariantsKitsCreate$XWwwFormUrlencoded$Response(
    params: ProjectCalculationsVariantsKitsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendScenarioDto>> {
    return projectCalculationsVariantsKitsCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * create and view scenarios
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectCalculationsVariantsKitsCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectCalculationsVariantsKitsCreate$XWwwFormUrlencoded(
    params: ProjectCalculationsVariantsKitsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendScenarioDto> {
    return this.projectCalculationsVariantsKitsCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendScenarioDto>): BackendScenarioDto => r.body),
    );
  }

  /**
   * create and view scenarios
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectCalculationsVariantsKitsCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectCalculationsVariantsKitsCreate$FormData$Response(
    params: ProjectCalculationsVariantsKitsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendScenarioDto>> {
    return projectCalculationsVariantsKitsCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * create and view scenarios
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectCalculationsVariantsKitsCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectCalculationsVariantsKitsCreate$FormData(
    params: ProjectCalculationsVariantsKitsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendScenarioDto> {
    return this.projectCalculationsVariantsKitsCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendScenarioDto>): BackendScenarioDto => r.body),
    );
  }

  /** Path part for operation `projectCalculationsVariantsKitsRetrieve()` */
  static readonly ProjectCalculationsVariantsKitsRetrievePath = '/api/project_calculations/variants_kits/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectCalculationsVariantsKitsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCalculationsVariantsKitsRetrieve$Response(
    params: ProjectCalculationsVariantsKitsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendScenarioDto>> {
    return projectCalculationsVariantsKitsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectCalculationsVariantsKitsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCalculationsVariantsKitsRetrieve(
    params: ProjectCalculationsVariantsKitsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendScenarioDto> {
    return this.projectCalculationsVariantsKitsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendScenarioDto>): BackendScenarioDto => r.body),
    );
  }

  /** Path part for operation `projectCalculationsVariantsKitsUpdate()` */
  static readonly ProjectCalculationsVariantsKitsUpdatePath = '/api/project_calculations/variants_kits/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectCalculationsVariantsKitsUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectCalculationsVariantsKitsUpdate$Response(
    params: ProjectCalculationsVariantsKitsUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendScenarioDto>> {
    return projectCalculationsVariantsKitsUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectCalculationsVariantsKitsUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectCalculationsVariantsKitsUpdate(
    params: ProjectCalculationsVariantsKitsUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendScenarioDto> {
    return this.projectCalculationsVariantsKitsUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendScenarioDto>): BackendScenarioDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectCalculationsVariantsKitsUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectCalculationsVariantsKitsUpdate$XWwwFormUrlencoded$Response(
    params: ProjectCalculationsVariantsKitsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendScenarioDto>> {
    return projectCalculationsVariantsKitsUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectCalculationsVariantsKitsUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectCalculationsVariantsKitsUpdate$XWwwFormUrlencoded(
    params: ProjectCalculationsVariantsKitsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendScenarioDto> {
    return this.projectCalculationsVariantsKitsUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendScenarioDto>): BackendScenarioDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectCalculationsVariantsKitsUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectCalculationsVariantsKitsUpdate$FormData$Response(
    params: ProjectCalculationsVariantsKitsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendScenarioDto>> {
    return projectCalculationsVariantsKitsUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectCalculationsVariantsKitsUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectCalculationsVariantsKitsUpdate$FormData(
    params: ProjectCalculationsVariantsKitsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendScenarioDto> {
    return this.projectCalculationsVariantsKitsUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendScenarioDto>): BackendScenarioDto => r.body),
    );
  }

  /** Path part for operation `projectCalculationsVariantsKitsDestroy()` */
  static readonly ProjectCalculationsVariantsKitsDestroyPath = '/api/project_calculations/variants_kits/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectCalculationsVariantsKitsDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCalculationsVariantsKitsDestroy$Response(
    params: ProjectCalculationsVariantsKitsDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return projectCalculationsVariantsKitsDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectCalculationsVariantsKitsDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCalculationsVariantsKitsDestroy(
    params: ProjectCalculationsVariantsKitsDestroy$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.projectCalculationsVariantsKitsDestroy$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `projectCalculationsVariantsKitsPartialUpdate()` */
  static readonly ProjectCalculationsVariantsKitsPartialUpdatePath = '/api/project_calculations/variants_kits/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectCalculationsVariantsKitsPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectCalculationsVariantsKitsPartialUpdate$Response(
    params: ProjectCalculationsVariantsKitsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendScenarioDto>> {
    return projectCalculationsVariantsKitsPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectCalculationsVariantsKitsPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectCalculationsVariantsKitsPartialUpdate(
    params: ProjectCalculationsVariantsKitsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendScenarioDto> {
    return this.projectCalculationsVariantsKitsPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendScenarioDto>): BackendScenarioDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectCalculationsVariantsKitsPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectCalculationsVariantsKitsPartialUpdate$XWwwFormUrlencoded$Response(
    params: ProjectCalculationsVariantsKitsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendScenarioDto>> {
    return projectCalculationsVariantsKitsPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectCalculationsVariantsKitsPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectCalculationsVariantsKitsPartialUpdate$XWwwFormUrlencoded(
    params: ProjectCalculationsVariantsKitsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendScenarioDto> {
    return this.projectCalculationsVariantsKitsPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendScenarioDto>): BackendScenarioDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectCalculationsVariantsKitsPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectCalculationsVariantsKitsPartialUpdate$FormData$Response(
    params: ProjectCalculationsVariantsKitsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendScenarioDto>> {
    return projectCalculationsVariantsKitsPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectCalculationsVariantsKitsPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectCalculationsVariantsKitsPartialUpdate$FormData(
    params: ProjectCalculationsVariantsKitsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendScenarioDto> {
    return this.projectCalculationsVariantsKitsPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendScenarioDto>): BackendScenarioDto => r.body),
    );
  }

  /** Path part for operation `projectCalculationsVariantsKitsEnumsRetrieve()` */
  static readonly ProjectCalculationsVariantsKitsEnumsRetrievePath =
    '/api/project_calculations/variants_kits/enums/{id}/';

  /**
   * This class returns all the variants for a given project
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectCalculationsVariantsKitsEnumsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCalculationsVariantsKitsEnumsRetrieve$Response(
    params: ProjectCalculationsVariantsKitsEnumsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return projectCalculationsVariantsKitsEnumsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * This class returns all the variants for a given project
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectCalculationsVariantsKitsEnumsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCalculationsVariantsKitsEnumsRetrieve(
    params: ProjectCalculationsVariantsKitsEnumsRetrieve$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.projectCalculationsVariantsKitsEnumsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }
}
